const appSyncConfig = {
  aws_appsync_graphqlEndpoint: "https://3dwtrrcfjfe7nmo3ft4wgwg3mm.appsync-api.ap-southeast-2.amazonaws.com/graphql",
  aws_appsync_region: "ap-southeast-2",
  aws_appsync_authenticationType: "AMAZON_COGNITO_USER_POOLS",
  aws_appsync_apiKey: "null",
};

export default appSyncConfig;
